import styled from 'styled-components'

import { hexToHsl, PB } from '@h2/components/colors'
import { features } from '@h2/components/media'
import { Flex as FlexBase } from '@h2/components/layout/flex'

const [hue, sat, light] = hexToHsl(PB)
const Flex = styled(FlexBase)`
  display: flex;
  grid-area: dtr;
  background-color: hsla(${hue}, ${sat}%, ${light}%, 0.05);
  padding: 15px 20px;
  min-height: 78px;

  p {
    font-weight: 700;
    width: 100%;
    text-align: center;

    a {
      text-decoration: underline;
      font-weight: 700;
      font-size: 16px;
    }
  }

  @media (${features.minWidth.laptop}) {
    display: ${({ useDetour }) => (useDetour ? 'flex' : 'none')};
    padding: 12px 10px;
    min-height: auto;
  }
`
const Detour = ({ children, ...rest }) => {
  return (
    <Flex {...rest} justifyContent="space-between" alignItems="center">
      {children}
    </Flex>
  )
}

Detour.slotName = 'PanelDetour'

export { Detour }
